import { z } from "zod";

const dropboxSignErrorTypeValues = [
  "NOT_IMPLEMENTED",
  "API_ERROR",
  "SIGNATURE_REQUEST_FAILED",
  "SIGN_URL_EXPIRED",
  "INVALID_STATE_TRANSITION",
  "CONCURRENT_WRITE_CONFLICT",
] as const;

const dropboxSignErrorTypeSchema = z.enum(dropboxSignErrorTypeValues);
const DropboxSignErrorType = dropboxSignErrorTypeSchema.enum;
type DropboxSignErrorType = z.infer<typeof dropboxSignErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type DropboxSignPackageErrors =
  | { errorType: typeof DropboxSignErrorType.NOT_IMPLEMENTED; data: undefined }
  | { errorType: typeof DropboxSignErrorType.API_ERROR; data: { message: string } }
  | { errorType: typeof DropboxSignErrorType.SIGNATURE_REQUEST_FAILED; data: { signatureRequestId?: string } }
  | { errorType: typeof DropboxSignErrorType.SIGN_URL_EXPIRED; data: { signerSignatureId: string } }
  | { errorType: typeof DropboxSignErrorType.INVALID_STATE_TRANSITION; data: { from: string; to: string } }
  | {
      errorType: typeof DropboxSignErrorType.CONCURRENT_WRITE_CONFLICT;
      data: { from: string; to: string };
    };

export const dropboxSignPackageErrorDetails: Record<DropboxSignErrorType, ErrorDetails> = {
  [DropboxSignErrorType.NOT_IMPLEMENTED]: {
    sentryDescription: "Dropbox Sign feature not yet implemented (Phase 2 stub)",
  },
  [DropboxSignErrorType.API_ERROR]: {
    sentryDescription: "Dropbox Sign API error",
  },
  [DropboxSignErrorType.SIGNATURE_REQUEST_FAILED]: {
    sentryDescription: "Dropbox Sign signature request failed",
  },
  [DropboxSignErrorType.SIGN_URL_EXPIRED]: {
    sentryDescription: "Dropbox Sign embedded sign URL expired or is invalid",
  },
  [DropboxSignErrorType.INVALID_STATE_TRANSITION]: {
    sentryDescription: "Dropbox Sign invalid state transition",
  },
  [DropboxSignErrorType.CONCURRENT_WRITE_CONFLICT]: {
    sentryDescription: "Dropbox Sign updateStatus matched zero rows; another writer changed status mid-flight",
  },
};
